export default "__VITE_ASSET__BZefmkd5__"